// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const LocationMarkerFilledIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="LocationMarkerFilledIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M10.064 17.94S16 11.414 16 8.064 13.314 2 10 2 4 4.715 4 8.065s6.064 9.874 6.064 9.874M10 10.636a2.7 2.7 0 1 1 0-5.399 2.7 2.7 0 0 1 0 5.4" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const LocationMarkerFilledIcon = /* @__PURE__ */ Object.assign(
  LocationMarkerFilledIconComponent,
  { displayName: 'LocationMarkerFilledIcon' },
);
